// Helper to load image on the DOM before rendering
export const _preloadImage = src =>
  new Promise((resolve, reject) => {
    var img = new window.Image()
    img.src = src
    img.onload = resolve
    img.onerror = reject
  })
